<div *ngIf="!showEmptyState">
	<app-idv-table
		[clients]="clients"
		(addClientEvent)="handleCheckboxClick($event)"
		[hasCheckboxes]="hasCheckboxes"
		[allClientsSelected]="allClientsSelected"
		[selectedClients]="selectedClients"
		(selectAllEvent)="selectAll($event)"
		(reviewModalEvent)="closeModal()"
	></app-idv-table>
</div>

<div *ngIf="showEmptyState" class="py-12 text-grey text-center text-lg">
	Add clients to begin the IDV process
</div>

<div class="flex justify-between mt-6 mx-5">
	<app-button
		size="small"
		btn="border"
		(onClick)="closeModal()"
		[testHook]="testHooks.CancelButton"
		>Cancel</app-button
	>

	<div class="flex gap-x-4">
		<span *ngIf="showSelectedCount" class="font-bold m-auto"
			>{{ selectedClients.length }}/{{ clients.length }} selected
		</span>
		<app-button
			*ngIf="showCancel"
			size="small"
			(onClick)="setModalStep(idvModalSteps.CANCEL_REQUESTS)"
			[disabled]="disableCancel"
			btn="border"
			[testHook]="testHooks.Button"
			>{{ getCancelButtonText() }}</app-button
		>
		<app-button
			size="small"
			(onClick)="setModalStep(idvModalSteps.SEND_REQUESTS)"
			[disabled]="disableSend"
			[testHook]="testHooks.SendButton"
			>{{ getSendButtonText() }}</app-button
		>
	</div>
</div>
